export default function (item) {
    // eslint-disable-next-line
    return item.map(({ name, selected_shop, selected_shop_store_view, ...marketData }) => ({
        ...marketData,
        title: name,
        shopId: parseInt(selected_shop, 10),
        storeId: parseInt(selected_shop_store_view, 10),
    }));
}
